import {Map, List, fromJS} from 'immutable';
import axios from "axios";
import { toast } from "react-toastify";

if (sessionStorage.getItem("authToken")) {
    axios.defaults.headers.common['Auth-Token'] = sessionStorage.getItem("authToken");
}

export const types = {
    INIT: 'USER/INIT',
    FETCH_USERS: 'USER/FETCH_USERS',
    FETCH_USERS_SUCCESS: 'USER/FETCH_USERS_SUCCESS'
};

export const initialState = fromJS({
    users: [],
    query: ''
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_USERS_SUCCESS:
            return state.set('users', fromJS(action.users));
        default:
            return state
    }
};

export const fetchUsers = () => {
    return function (dispatch) {

        const path = __API__ + '/api/ui/user';

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(users => {
                dispatch(fetchUsersSuccess(users));
            })
            .catch(error => {
                toast.error('Nutzer konnten nicht geladen werden!');
            });
    }
};

export const fetchUsersSuccess = (users) => {
    return {
        type: types.FETCH_USERS_SUCCESS,
        users: users
    };
};

export const createNewUser = (user) => {
    return function (dispatch, getState) {
        const path = __API__ + '/api/ui/user';

        const command = {
            username: user.username,
            password: user.password
        };

        return axios.post(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchUsers());
                toast.success(`Benutzer ${user.username} wurde angelegt!`);
            })
            .catch(error => {
                dispatch(fetchUsers()).then(() => {
                    toast.error(`Benutzer ${user.username} konnte nicht angelegt werden!!`);
                });
            });
    }
};

export const changePassword = (username, newPassword) => {
    return function (dispatch, getState) {
        const path = __API__ + `/api/ui/user/${username}/password`;

        const command = {
            username: username,
            newPassword: newPassword
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                toast.success('Passwort erfolgreich geändert!\'');
            })
            .catch(error => {
                toast.error('Passwortänderung konnte nicht gespeichert werden!');
            });
    }
};



// WEBPACK FOOTER //
// ./src/admin/user/reducer.js